import { render, staticRenderFns } from "./ShopMapper.vue?vue&type=template&id=d680df50&scoped=true"
import script from "./ShopMapper.vue?vue&type=script&lang=js"
export * from "./ShopMapper.vue?vue&type=script&lang=js"
import style0 from "./ShopMapper.vue?vue&type=style&index=0&id=d680df50&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d680df50",
  null
  
)

export default component.exports